module.exports = __webpack_public_path__ + "static/media/Main-Slider-Dic-2023.def26c7b.jpg";